export default "mutation requestQuoteV2($request: RequestQuoteInputV2!){\n  requestQuoteV2(request: $request)\n}";